import * as MixpanelSettings from '../../react/infra/mixpanel/MixpanelSettings';
import { getFirstPartyDataByUser, deleteFirstPartySegment } from '../../react/services/AudienceInsightsService';
import { isDmpRecentSegment } from '../../react/utils/segmentUtils';
var c = require('infra/utils/common');

const {
  FIRST_PARTY_SOURCE_ENUM,
  FIRST_PARTY_PERMISSION,
} = require('./first_party_constants');

angular.module(__filename, [
    require('./edit-segment.js').name
  ]
).controller('FirstPartySegmentsController',
  ['$scope', 'programService', 'ModalService', 'confirmAction', 'util', '$timeout', 'abiPermissions',
  function($scope, programService, ModalService, confirmAction, util, $timeout, abiPermissions) {
    const DISCOVERY_SEGMENT_SOURCE = FIRST_PARTY_SOURCE_ENUM.DISCOVERY;
    const DMP_SEGMENT_SOURCE = FIRST_PARTY_SOURCE_ENUM.DMP;

    $scope.columns = [
      {label: 'Segment', field: 'name', sortable: true, cssClass: 'segment-name'},
      {label: 'Program', field: 'programs', sortable: true, cssClass: 'program-name'},
      {label: 'Created By', field: 'creator.first_name', sortable: true, cssClass: 'created-by'},
      {label: 'Created On', field: 'created_at', sortable: true, cssClass: 'created-on'},
      {label: 'Last Update', field: 'updated_at', sortable: true, cssClass: 'last-update'},
      {label: 'Source', field: 'first_party_source_id', sortable: true, cssClass: 'source'},
      {label: 'Discovery Users', field: 'segment_size', sortable: true, cssClass: 'discovery-users'},
      {label: 'DMP Segment ID', field: 'dmp_segment_id', sortable: true, cssClass: 'dmp-segment-id'},
      {label: 'Segment Expiration', field: 'segment_expiration', sortable: true, cssClass: 'segment-expiration'}
    ];

    populate();

    MixpanelSettings.trackPageView('first_party');

    function populate() {
      getFirstPartyDataByUser($scope.$root.user.id).then((data) => $timeout(function () {
        const hasMySegmentsProgramPermission = abiPermissions.hasPermission('my segments program');
        $scope.segments = _.filter(data, (segment) => hasMySegmentsProgramPermission || 
                                                          [DISCOVERY_SEGMENT_SOURCE, DMP_SEGMENT_SOURCE].includes(segment.first_party_source_id));
        $scope.gotData = true;
      }));
      programService.userProgramsList($scope.$root.user.id).then(function (data) {
        let programs = _.reject(data, (prog) => util.isMyInterestsProgram(prog) || util.isMySegmentsProgram(prog));
        $scope.user_programs = _.map(programs, function (p) {
          let program = _.clone(p);
          program.text = program.name;
          return program;
        });
      });
    }

    $scope.deleteSegment = function (id, segment_value) {
      const idMap = _.map($scope.segments, 'id');
      const selectedIndex = idMap.indexOf(id);

      const confirmationMsg = "Are you sure you want to delete the first party segment " + $scope.segments[selectedIndex].name + "?" + " In case there is an active syndication, it will be automatically disabled";
      const txtConfirm = 'Yes';
      const txtCancel = 'No';

      confirmAction.getConfirmation(confirmationMsg, txtConfirm, txtCancel).then(function (modal) {
        modal.close.then(function (confirmation) {
          if (confirmation) executeDelete(id, segment_value);
        });
      });

      function executeDelete(id, segment_value) {
        deleteFirstPartySegment(id, segment_value).then(function () {
          $scope.segments.splice(selectedIndex, 1);
          // Force a digest cycle to ensure the UI is updated because the delete is async
          $scope.$apply();
        });
      }
    };

    $scope.editSegment = function (segment) {
      OpenEditSegmentModal({newSegment: !segment,
                            segment: segment || {},
                            userPrograms: $scope.user_programs,
                            allSegments: segment ? _.reject($scope.segments, {name: segment.name}) : $scope.segments});
    };

    $scope.programsText = function (segment) {
      if([DISCOVERY_SEGMENT_SOURCE, DMP_SEGMENT_SOURCE].includes(segment.first_party_source_id)) {
        return segment.programs.length > 1 ? segment.programs.length + " Programs" : (segment.programs[0] || {}).name;
      } else {
        return segment.programs.length > 0 ? (segment.programs.length + 1) + " Programs" : "My Segments";
      }
    };

    $scope.canDeleteSegment = (segment) => segment.first_party_source_id === DISCOVERY_SEGMENT_SOURCE ||
                                           segment.first_party_source_id === DMP_SEGMENT_SOURCE;

    $scope.isDmpRecentSegment = isDmpRecentSegment;

    function OpenEditSegmentModal(inputs) {
      ModalService.showModal({
        template: require('./edit-segment.html'),
        inputs: inputs,
        controller: 'editSegmentController'
      }).then(function (modal) {
        modal.close.then(function (result) {
          if (result !== undefined && result.reload) {
            populate();
          }
        });
      });
    }

    $scope.sortByPrograms = function(segment) {
      const programsTextToSort = $scope.programsText(segment);
      return $scope.reverse ? -programsTextToSort : programsTextToSort;
    };
    
    // Set default sort to 'Created On' descending
    $scope.predicate = 'created_at';
    $scope.reverse = true;
    $scope.order = function (predicate) {
      $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
      $scope.predicate = predicate;
    };
  }
]).stateConfig = {
  name: 'first_party',
  url: '/first_party',
  template: require('./first_party.html'),
  controller: 'FirstPartySegmentsController',
  data: {
    permissions: [FIRST_PARTY_PERMISSION]
  },
  redirectTo: ['abiPermissions', function(abiPermissions) {
    if (!abiPermissions.hasPermission(FIRST_PARTY_PERMISSION)) {
      return 'settings.programs';
    }
  }],
  display: '1st Party Segments'
};

module.exports = angular.module(__filename);
module.exports.FIRST_PARTY_SOURCE_ENUM = FIRST_PARTY_SOURCE_ENUM;
